import backend from '../../components/utils/backend'

export default {
  state: {
    jobs: []
  },
  mutations: {
    'SET_JOBS': function (state, jobs) {
      state.jobs = jobs
    }
  },
  actions: {
    getJobs ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const jobsList = (await backend.get('/api/v1/job', rootGetters['session/accessToken'])).body
          commit('SET_JOBS', jobsList)
          resolve(jobsList)
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  namespaced: true
}
